import { render, staticRenderFns } from "./fankuiInfo.vue?vue&type=template&id=13543db4&scoped=true&"
import script from "./fankuiInfo.vue?vue&type=script&lang=js&"
export * from "./fankuiInfo.vue?vue&type=script&lang=js&"
import style0 from "./fankuiInfo.vue?vue&type=style&index=0&id=13543db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13543db4",
  null
  
)

export default component.exports